module.exports = __webpack_public_path__ + "web/media/bg.7a2c9048.jpg";